export default "__VITE_ASSET__Bh0JpAG3__"